export default {
    methods: {
        changeClient(e) {
            if (e.key && !this.filters.clients.find((item) => item.key === e.key)) {
                this.filters.clients.push({ key: e.key, label: e.label, color: this.getTagColor() })
                this.filters.allClients = false
            }
        },
        getTagColor() {
            const colors = ['#1b55e3', '#FFC83D', '#25CF73', '#652eff', '#f2a654', '#fd3995']
            const randomIndex = Math.floor(Math.random() * colors.length)
            return colors[randomIndex]
        },
        handlerDeleteClient(key) {
            this.filters.clients = this.filters.clients.filter((item) => item.key !== key)
        },
        handlerFilter() {
            const fields = {}
            fields.invoice = {
                type: 'string',
                value: null,
                opt: '=',
            }
            if (this.filters.from && this.filters.to) {
                fields.date = {
                    type: 'date',
                    from: this.$moment(this.filters.from).format('YYYY-MM-DD'),
                    to: this.$moment(this.filters.to).format('YYYY-MM-DD'),
                }
            }
            if (this.filters.clients.length && !this.filters.allClients) {
                fields.client = {
                    type: 'select',
                    string: this.filters.clients.map((item) => parseInt(item.key)),
                }
            }
            const params = {
                search: '',
                strict: false,
                filter: [
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: fields,
                    },
                ],
                limit: 20,
                order: null,
            }
            this.$query(this.view).set(params)
        },
        handlerCleanFilter() {
            this.filters.client = { key: null, label: '' }
            this.filters.clients = []
            this.filters.allClients = true
            this.filters.from = ''
            this.filters.to = ''
            this.handlerFilter()
        },
        openForm(item) {
            this.$router.push({
                name: 'invoicesEdit',
                params: { id: item._EntityId },
            })
        },
    },
}
